// Global
import graphqlClientFactory from 'lib/graphql-client-factory';
import ArticleCategoryTabsQuery from 'components/authorable/shared/page-specific/ArticleCategoryTabs.graphql';
import PopularArticlesClient from './PopularArticlesClient';
export const Default = PopularArticlesClient;
